<template>
    <div>
        <div id="pano" class="TQ_height_50p"></div>
        <div id="map" class="TQ_height_50p"></div>
    </div>
</template>

<script>

    import {validator_enum_fb} from '../../../functions/src/shareCode/Share_S_Validator'
    import {enum_langCodes} from '../../../functions/src/shareCode/Share_S_Enum'
    import {GoogleMap_TxtOverlay, GoogleMap_TxtOverlay_init} from "../../classes/GoogleMap_TxtOverlay";
    import {obj_map_fo, obj_toArray_fo} from '../../../functions/src/shareCode/Share_S_Obj'
    import {FB_MapData, FB_MapPoint} from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "TqGoogleMap",
        props: {

            p_display_langCode_e:{
                type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },

            // map settings
            pb_centerMap_c : {
                type: FB_MapPoint,
                require: true
            },
            pb_zoom_n:{
                type: Number,
                require: true
            },

            // draw on map
            p_polygons_a_byIndex_c:{
                type: Array,
                default() {
                    return []
                }
            },
            p_rectangles_ac:{
                type:Array,
                default() {
                    return []
                }
            },
            p_rectanglesDisplayImagesIndexes_an:{
                type: Array,
                default() {
                    return []
                },
            },

            p_mobileMode_b:{
                type: Boolean,
                default: false
            },

            // on click
            pe_onClickRiddle_f:{
                type: Function,
                require: true
            },

        },
        data(){
            return {
                googleMap : null,

                displayedRectanglesImagesIndexes_an : []
            }
        },
        methods:{

            mounted_importGoogleMapApi(cb_f){

                const el = document.getElementById('googleMapApi');
                if(el !== null) {
                    cb_f()
                    return
                }

                let imported = document.createElement('script');
                imported.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?language=' + this.p_display_langCode_e + '&key=AIzaSyBWJKGmpKoALINEqvf6KX5HWQg6CRTdnwM')
                imported.setAttribute('async', '')
                imported.setAttribute('defer', '')
                imported.setAttribute('id', 'googleMapApi')
                document.head.appendChild(imported);
                imported.onload = () => {cb_f()}
            },
            m_initMap_f(){
                this.googleMap =  new google.maps.Map(document.getElementById('map'), {
                    center: {lat: this.pb_centerMap_c.mp_lat_n, lng : this.pb_centerMap_c.mp_lng_n},
                    zoom: this.pb_zoom_n,
                    mapTypeControl: false,
                    // streetViewControl: false,
                    fullscreenControl: false,
                    // zoomControl: false,
                    // gestureHandling: 'cooperative'
                });

                let panorama = new google.maps.StreetViewPanorama(
                    document.getElementById('pano'), {
                        position: {lat: this.pb_centerMap_c.mp_lat_n, lng : this.pb_centerMap_c.mp_lng_n},
                        // pov: {
                        //     heading: 34,
                        //     pitch: 10
                        // },
                        // fullscreenControl: false,
                        imageDateControl: true,


                        // addressControlOptions: false,
                        addressControl: false,
                        // showRoadLabels : true

                        // zoomControl: false,
                    });

                this.googleMap.setStreetView(panorama);

                let svLayer = new google.maps.StreetViewCoverageLayer();
                svLayer.setMap(this.googleMap);

            },
            m_drawPolygons_f(){

                this.p_polygons_a_byIndex_c.forEach(polygon_byIndex_c => {

                    let polygon_p = new google.maps.Polygon({
                        paths: obj_toArray_fo(obj_map_fo(polygon_byIndex_c, (point_c) => {return [point_c.mp_lat_n, point_c.mp_lng_n]})),
                        strokeColor: '#800080',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#800080',
                        fillOpacity: 0.35,
                    });

                    polygon_p.setMap(this.googleMap);
                })



            },

            m_drawRectangles_f(){


                if(this.p_rectangles_ac.length > 0 ){
                    GoogleMap_TxtOverlay_init()
                }


                this.p_rectangles_ac.forEach((qb_riddle_c, index_n) => {

                    // set rectangle
                    let rectangle = new google.maps.Rectangle({
                        strokeColor: 'purple',
                        strokeOpacity: 1.0,
                        strokeWeight: 1,
                        fillColor: 'transparent',
                        fillOpacity: 0.35,
                        map: this.googleMap,
                        bounds: {
                            north: qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + qb_riddle_c.qbr_rectangleSize_c.mp_lat_n/2,
                            south: qb_riddle_c.qbr_riddlePosition_c.mp_lat_n - qb_riddle_c.qbr_rectangleSize_c.mp_lat_n/2,
                            east: qb_riddle_c.qbr_riddlePosition_c.mp_lng_n + qb_riddle_c.qbr_rectangleSize_c.mp_lng_n/2,
                            west: qb_riddle_c.qbr_riddlePosition_c.mp_lng_n - qb_riddle_c.qbr_rectangleSize_c.mp_lng_n/2
                        },
                    });

                    // set text number
                    let txt = new GoogleMap_TxtOverlay(
                        new google.maps.LatLng(qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + qb_riddle_c.qbr_rectangleSize_c.mp_lat_n/2, qb_riddle_c.qbr_riddlePosition_c.mp_lng_n - qb_riddle_c.qbr_rectangleSize_c.mp_lng_n/2),
                        `<div class='TQ_text_24px TQ_margin_4px'> ${index_n + 1} </div>`)
                    txt.setMap(this.googleMap)

                    // set on click listener
                    if(this.pe_onClickRiddle_f){
                        rectangle.addListener('click', () => {this.pe_onClickRiddle_f(index_n)});
                    }


                })
            },
            m_drawRectanglesImgs_f(){


                this.p_rectanglesDisplayImagesIndexes_an.forEach((rectangleIndex_n) => {

                    // check display svg
                    if (this.displayedRectanglesImagesIndexes_an.includes(rectangleIndex_n)) {
                        return
                    }
                    this.displayedRectanglesImagesIndexes_an.push(rectangleIndex_n)


                    let qb_riddle_c = this.p_rectangles_ac[rectangleIndex_n]

                    if (qb_riddle_c.qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s == null) {return}

                    new google.maps.GroundOverlay(
                        qb_riddle_c.qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s,
                        {
                            south   : qb_riddle_c.qbr_riddlePosition_c.mp_lat_n - qb_riddle_c.qbr_rectangleSize_c.mp_lat_n/2,
                            north   : qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + qb_riddle_c.qbr_rectangleSize_c.mp_lat_n/2,
                            west    : qb_riddle_c.qbr_riddlePosition_c.mp_lng_n - qb_riddle_c.qbr_rectangleSize_c.mp_lng_n/2,
                            east    : qb_riddle_c.qbr_riddlePosition_c.mp_lng_n + qb_riddle_c.qbr_rectangleSize_c.mp_lng_n/2
                        },
                        {
                            opacity:0.6
                        }
                    ).setMap(this.googleMap);


                })


            }

        },
        mounted(){


            // set map script
            this.mounted_importGoogleMapApi( () => {

                // 1) init map
                this.m_initMap_f()

                // 2) draw polygons
                this.m_drawPolygons_f()

                // 3) draw rectangles
                this.m_drawRectangles_f()

                // 4) draw rectangles svg
                this.m_drawRectanglesImgs_f()

            })

        }
    }
</script>

<style >

    /*.gm-iv-address,*/
    /*div.gmnoprint.gm-style-cc,*/
    /*#map > div > div > div:nth-child(5),*/
    /*!*#map > div > div > div:nth-child(3),*!*/
    /*!*#map > div > div > div:nth-child(9),*!*/
    /*#pano > div > div:nth-child(4),*/
    /*#pano > div > div:nth-child(13),*/
    /*!*#pano > div > div:nth-child(2) > a > div > img *!*/
    /*{*/
        /*display: none!important;*/
    /*}*/


</style>